<script>
/**
 * Phone call-back queue (Suleman's handover, 14 Oct 2026): requests from app.thegpservice.co.uk/phone-consultation.
 * Endpoints: /api/admin/callback-requests (admin sign-in required).
 */
const CallbackService = {};

CallbackService.install = function (Vue) {
  const service = {};
  Object.defineProperty(Vue.prototype, '$callbackService', { value: service });

  const base = '/api/admin/callback-requests';
  const data = response => (response.data && response.data.data !== undefined ? response.data.data : response.data);

  /** Error text from the API ("Hiba has already picked this up", "Add the booked time", …). */
  service.errorMessage = function (error, fallback) {
    const body = error && error.response && error.response.data;
    if (body && typeof body.message === 'string' && body.message) {
      return body.message;
    }
    return fallback || 'Something went wrong. Please try again.';
  };

  /** 401: the admin's session has expired (or was signed out elsewhere). */
  service.isSignedOut = function (error) {
    return !!(error && error.response && error.response.status === 401);
  };

  service.isConflict = function (error) {
    return !!(error && error.response && error.response.status === 409);
  };

  /** view: 'open' (to call) or 'all' (latest 200). */
  service.list = function (view = 'open') {
    return Vue.axios.get(base + '?view=' + encodeURIComponent(view)).then(data);
  };

  service.summary = function () {
    return Vue.axios.get(base + '/summary').then(data);
  };

  service.detail = function (id) {
    return Vue.axios.get(base + '/' + id).then(data);
  };

  service.pickUp = function (id, takeOver = false) {
    return Vue.axios.post(base + '/' + id + '/pick-up', { takeOver: takeOver }).then(data);
  };

  /** payload: { outcome, note, bookedSlot, fee } */
  service.outcome = function (id, payload) {
    return Vue.axios.post(base + '/' + id + '/outcome', payload).then(data);
  };

  /** Who gets the alerts (team emails, lead emails, WhatsApp numbers). Any admin can change them. */
  service.settings = function () {
    return Vue.axios.get(base + '/settings').then(data);
  };

  /** payload: { teamEmails: [], leadEmails: [], teamWhatsApp: [], leadWhatsApp: [] } */
  service.saveSettings = function (payload) {
    return Vue.axios.put(base + '/settings', payload).then(data);
  };

  /** Emails the saved team list. Resolves { status: 'sent' | 'failed' | 'off', to: [] }. */
  service.testSettings = function () {
    return Vue.axios.post(base + '/settings/test').then(data);
  };

  /** Field errors from a 400 ({ teamEmails: 'Not a valid email: ...' }). */
  service.fieldErrors = function (error) {
    const body = error && error.response && error.response.data;
    return (body && body.data && body.data.fields) || {};
  };

  service.linkPatient = function (id, patientId) {
    return Vue.axios.post(base + '/' + id + '/patient', { patientId: patientId }).then(data);
  };

  service.addNote = function (id, note) {
    return Vue.axios.post(base + '/' + id + '/note', { note: note }).then(data);
  };
};

export default CallbackService;
</script>
